import { MutableRefObject, useRef } from "react";

/**
 * React state hook that returns the latest state
 */
function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);

  ref.current = value;

  return ref;
}

export default useLatest;
